module.exports = __webpack_public_path__ + "img/16.34b35fd6.jpg";